import React from "react";
import { cn } from "../lib/utils";

export const GlassCard = ({ className, children, ...props }) => {
  return (
    <div
      className={cn(
        "bg-white/70 backdrop-blur-xl border border-white/60 shadow-[0_4px_24px_rgba(0,0,0,0.04)] rounded-2xl p-6 md:p-8 relative overflow-hidden transition-all duration-300",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const KpiCard = ({ label, value, sub, accent = "indigo", testId }) => {
  const accentMap = {
    indigo: "text-indigo-950",
    emerald: "text-emerald-700",
    amber: "text-amber-700",
    rose: "text-rose-700",
    slate: "text-slate-800",
  };
  return (
    <GlassCard
      data-testid={testId}
      className="flex flex-col gap-2 hover:shadow-md hover:-translate-y-0.5"
    >
      <span className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
        {label}
      </span>
      <span className={cn("text-3xl font-medium tracking-tight", accentMap[accent])} style={{ fontFamily: "Outfit, sans-serif" }}>
        {value}
      </span>
      {sub ? <span className="text-sm text-slate-500">{sub}</span> : null}
    </GlassCard>
  );
};
